import {
  GET_SURVEYS,
  GET_SURVEY,
  CREATE_SURVEY,
  UPDATE_SURVEY,
  DELETE_SURVEYS,
  GET_SURVEY_RESULTS,
  GETTING_SURVEYS,
  GETTING_SURVEY,
  GETTING_SURVEY_RESULTS,
  CREATING_SURVEY,
  UPDATING_SURVEY,
  DELETING_SURVEYS,
  GETTING_SURVEY_SUCCEEDED,
  GETTING_SURVEYS_SUCCEEDED,
  GETTING_SURVEY_RESULTS_SUCCEEDED,
  CREATING_SURVEY_SUCCEEDED,
  UPDATING_SURVEY_SUCCEEDED,
  DELETING_SURVEYS_SUCCEEDED,
  GETTING_SURVEYS_FAILED,
  GETTING_SURVEY_FAILED,
  GETTING_SURVEY_RESULTS_FAILED,
  CREATING_SURVEY_FAILED,
  UPDATING_SURVEY_FAILED,
  DELETING_SURVEYS_FAILED,
  SET_CURRENT_SURVEY,
  SET_COPY_CURRENT_SURVEY,
  UNSET_CURRENT_SURVEY,
  CLEAR_SURVEY_ERROR,
  CLEAR_SURVEY_STORE,
  SAVE_SURVEY_LOGO,
  SAVING_SURVEY_LOGO,
  SAVING_SURVEY_LOGO_SUCCEEDED,
  SAVING_SURVEY_LOGO_FAILED,
  GETTING_SURVEY_LOGO_URL_SUCCEEDED,
  GETTING_INDIVIDUAL_SURVEY_RESULTS_SUCCEEDED,
  GETTING_INDIVIDUAL_SURVEY_RESULTS_FAILED,
  GETTING_INDIVIDUAL_SURVEY_RESULTS,
  GET_INDIVIDUAL_SURVEY_RESULTS,
  SEND_SURVEY_RESULT_RESPONSE_SUCCEEDED,
  SEND_SURVEY_RESULT_RESPONSE_FAILED,
  SEND_SURVEY_RESULT_RESPONSE,
  CLOSE_SENT_RESPONSE_SNACKBAR,
  SET_SURVEY_SETTINGS_DATA,
  UNSET_SURVEY_SETTINGS_DATA,
  GET_PAGINATED_SURVEYS,
  GETTING_PAGINATED_SURVEYS,
  GETTING_PAGINATED_SURVEYS_SUCCEEDED,
  GETTING_PAGINATED_SURVEYS_FAILED,
  GET_MINIMAL_SURVEYS,
  GETTING_MINIMAL_SURVEYS,
  GETTING_MINIMAL_SURVEYS_SUCCEEDED,
  GETTING_MINIMAL_SURVEYS_FAILED,
  GET_ASSOCIATED_CAMPAIGNS,
  GETTING_ASSOCIATED_CAMPAIGNS,
  GETTING_ASSOCIATED_CAMPAIGNS_SUCCEEDED,
  GETTING_ASSOCIATED_CAMPAIGNS_FAILED,
  GET_GUEST_DETAILS,
  GETTING_GUEST_DETAILS,
  GETTING_GUEST_DETAILS_SUCCEEDED,
  GETTING_GUEST_DETAILS_FAILED,
  GET_SURVEY_RESULT_CSV_FILE,
  GETTING_SURVEY_RESULT_CSV_FILE_SUCCEEDED,
  GETTING_SURVEY_RESULT_CSV_FILE_FAILED,
  DOWNLOADED_SURVEY_RESULT_CSV_FILE,
  UPDATE_SURVEY_HASH_FILTER,
  UPDATE_SURVEY_RESULTS_DETAILS,
  UPDATE_EVENT_ID_FILTER,
  UPDATE_EVENT_ID_WITHOUT_EFFECTS,
  UPDATE_SURVEY_FILTERS,
  RESET_SURVEY_FILTERS,
  UPDATE_INDIVIDUAL_SURVEY_RESULT_FILTERS,
  RESET_INDIVIDUAL_SURVEY_RESULT_FILTERS,
  UPDATE_SURVEY_RESULT_FILTERS,
  RESET_SURVEY_RESULT_FILTERS
} from './actions';
import { createReducer } from '@reduxjs/toolkit';
import { ProductType } from 'constants.js';

const initialState = {
  getting: false,
  gettingPaginated: true,
  gettingMinimal: false,
  creating: false,
  creatingPaginated: false,
  updating: false,
  deleting: false,
  deletingPaginated: false,
  gettingAssociatedCampaigns: false,
  gettingGuestDetails: false,
  list: [],
  paginatedList: [],
  minimalList: [],
  minimalTotalRecords: 0,
  current: {
    name: '',
    surveyTheme: {
      primaryColor: '#43a047',
      secondaryColor: '#ffffff',
      fontFamily: 'Times New Roman,serif',
      fontSize: 14
    },
    productType: ProductType.Product
  },
  previewUrl: null,
  results: {},
  individualResults: {},
  sendResponseSuccess: false,
  openSentResponseSnackbar: false,
  surveySettingsData: {},
  isTemplateSaved: false,
  error: {
    message: null,
    raw: null
  },
  filters: {
    searchInput: '',
    displayActive: true,
    sortBy: 'name',
    sortOrder: 'ASC',
    rowsPerPage: 10,
    pageNo: 0,
    totalCount: 0,
    filterTypes: [],
    filterTemplates: [],
    filterProductNames: [],
    filterProductCategories: [],
    filterTags: [],
  },
  individualSurveyResultFilters: {
    rowsPerPage: 10,
    pageNo: 0,
    totalCount: 0,
    sortBy: 'name',
    sortOrder: 'ASC',
    filterTypes: [],
    filterTags: [],
    filterStartDate: null,
    filterEndDate: null,
    filterSurveyQuestions: []
  },
  surveyResultFilters: {
    filterTags: [],
    filterStartDate: null,
    filterEndDate: null,
  },
  surveyHashFilter: [],
  surveyResultDetails: {},
  eventId: null,
  campaignUuid: null,
  gettingSurveyResults: false,
  guestDetails: {},
  associatedCampaignList: [],
  surveyResultCsv: {
    getting: false,
    gettingFileSucceeded: false,
    surveyResultCsvBlob: {},
    isDownloading: false
  },
};

export default createReducer(initialState, {
  [GET_SURVEYS]: state => {
    return state;
  },
  [GET_SURVEY]: state => {
    return state;
  },
  [GET_PAGINATED_SURVEYS]: state => {
    return state;
  },
  [GETTING_PAGINATED_SURVEYS]: state => {
    state.gettingPaginated = true;
    return state;
  },
  [GETTING_PAGINATED_SURVEYS_SUCCEEDED]: (state, action) => {
    state.gettingPaginated = false;
    state.paginatedList = action.payload.data.map(template => ({
      ...template
    }));
    return state;
  },
  [GETTING_PAGINATED_SURVEYS_FAILED]: (state, action) => {
    state.gettingPaginated = false;
    state.creatingPaginated = false;
    state.deletingPaginated = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [GET_MINIMAL_SURVEYS]: state => {
    return state;
  },
  [GETTING_MINIMAL_SURVEYS]: state => {
    state.gettingMinimal = true;
    return state;
  },
  [GETTING_MINIMAL_SURVEYS_SUCCEEDED]: (state, action) => {
    state.gettingMinimal = false;
    state.minimalList = action.payload.data || [];
    state.minimalTotalRecords = action.payload.totalRecords || 0;
    return state;
  },
  [GETTING_MINIMAL_SURVEYS_FAILED]: (state, action) => {
    state.gettingMinimal = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [UPDATE_SURVEY_HASH_FILTER]: (state, action) => {
    state.surveyHashFilter = action.payload;
    if (action.payload.length === 0) {
      state.gettingSurveyResults = false;
    }
    return state;
  },
  [UPDATE_SURVEY_RESULTS_DETAILS]: (state, action) => {
    state.gettingSurveyResults = false;
    state.surveyResultDetails = action.payload
    return state;
  },
  [UPDATE_EVENT_ID_FILTER]: (state, action) => {
    let { eventId, campaignUuid } = action.payload;
    state.gettingSurveyResults = true;
    state.eventId = eventId;
    state.campaignUuid = campaignUuid ? campaignUuid : null;
    return state;
  },
  [UPDATE_EVENT_ID_WITHOUT_EFFECTS]: (state, action) => {
    state.eventId = action.payload;
    return state;
  },
  [GET_ASSOCIATED_CAMPAIGNS]: state => {
    state.error = {};
    return state;
  },
  [GETTING_ASSOCIATED_CAMPAIGNS]: state => {
    state.gettingAssociatedCampaigns = true;
    return state;
  },
  [GETTING_ASSOCIATED_CAMPAIGNS_SUCCEEDED]: (state, action) => {
    state.gettingAssociatedCampaigns = false;
    state.associatedCampaignList = action.payload;
    return state;
  },
  [GETTING_ASSOCIATED_CAMPAIGNS_FAILED]: (state, action) => {
    state.gettingAssociatedCampaigns = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [GET_GUEST_DETAILS]: state => {
    state.error = {};
    return state;
  },
  [GETTING_GUEST_DETAILS]: state => {
    state.gettingGuestDetails = true;
    return state;
  },
  [GETTING_GUEST_DETAILS_SUCCEEDED]: (state, action) => {
    state.gettingGuestDetails = false;
    state.guestDetails = action.payload;
    return state;
  },
  [GETTING_GUEST_DETAILS_FAILED]: (state, action) => {
    state.gettingGuestDetails = false;
    state.guestDetails = {};
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [CREATE_SURVEY]: state => {
    state.getting = true;
    state.creating = true;
    state.isTemplateSaved = false;
    return state;
  },
  [UPDATE_SURVEY]: state => {
    state.getting = true;
    state.updating = true;
    state.isTemplateSaved = false;
    return state;
  },
  [DELETE_SURVEYS]: (state, action) => {
    return state;
  },
  [GET_SURVEY_RESULTS]: state => {
    return state;
  },
  [GETTING_SURVEYS]: state => {
    state.getting = true;
    return state;
  },
  [GETTING_SURVEY]: state => {
    state.getting = true;
    return state;
  },
  [GETTING_SURVEY_RESULTS]: state => {
    state.getting = true;
    return state;
  },
  [CREATING_SURVEY]: state => {
    state.getting = true;
    state.creating = true;
    state.current = {
      ...state.current,
      active: state.current.active === undefined ? true : state.current.active
    };
    return state;
  },
  [UPDATING_SURVEY]: state => {
    state.getting = true;
    state.updating = true;
    return state;
  },
  [DELETING_SURVEYS]: state => {
    state.deleting = true;
    return state;
  },
  [GETTING_SURVEY_SUCCEEDED]: (state, action) => {
    const { survey } = action.payload;

    state.getting = false;
    state.creating = false;
    state.updating = false;
    state.current = {
      ...survey,
      surveyTheme: survey.surveyTheme || state.current.surveyTheme
    };
    return state;
  },
  [CREATING_SURVEY_SUCCEEDED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.updating = false;
    state.current = { ...action.payload };
    state.isTemplateSaved = true;
    return state;
  },
  [UPDATING_SURVEY_SUCCEEDED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.updating = false;
    state.current = { ...action.payload };
    state.isTemplateSaved = true;
    return state;
  },
  [DELETING_SURVEYS_SUCCEEDED]: (state, action) => {
    state.deletingPaginated = false;
    state.current = action.payload.find(id => id === state.current.id)
      ? {}
      : state.current;
    state.paginatedList = state.paginatedList.map(survey => {
      if (survey.id === action.payload[0]) {
        survey.active = !survey.active;
      }
      return survey;
    });
    return state;
  },
  [GETTING_SURVEYS_SUCCEEDED]: (state, action) => {
    state.getting = false;
    state.list = action.payload.map(survey => ({
      ...survey,
      surveyTheme: survey.surveyTheme || state.current.surveyTheme
    }));
    return state;
  },
  [GETTING_SURVEY_RESULTS_SUCCEEDED]: (state, action) => {
    state.getting = false;
    state.results = action.payload.surveyResults;
    return state;
  },
  [GETTING_SURVEYS_FAILED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.deleting = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [GETTING_SURVEY_FAILED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.deleting = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [GETTING_SURVEY_RESULTS_FAILED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.deleting = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [GET_INDIVIDUAL_SURVEY_RESULTS]: state => {
    state.getting = true;
    return state;
  },
  [GETTING_INDIVIDUAL_SURVEY_RESULTS]: state => {
    state.getting = true;
    state.individualResults = {};
    return state;
  },
  [GETTING_INDIVIDUAL_SURVEY_RESULTS_SUCCEEDED]: (state, action) => {
    state.getting = false;
    state.sendResponseSuccess = false;
    state.openSentResponseSnackbar = false;
    state.individualResults = action.payload.surveyResults;
    return state;
  },
  [GETTING_INDIVIDUAL_SURVEY_RESULTS_FAILED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.deleting = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [CREATING_SURVEY_FAILED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.deleting = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    state.isTemplateSaved = false;
    return state;
  },
  [UPDATING_SURVEY_FAILED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.deleting = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    state.isTemplateSaved = false;
    return state;
  },
  [DELETING_SURVEYS_FAILED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.deleting = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },

  [SET_CURRENT_SURVEY]: (state, action) => {
    state.previewUrl = null;
    state.current = {
      ...action.payload
    };
    state.isTemplateSaved = false;
    return state;
  },
  [UNSET_CURRENT_SURVEY]: state => {
    state.current = { ...initialState.current };
    return state;
  },
  [CLEAR_SURVEY_ERROR]: state => {
    state.error = { ...initialState.error };
    return state;
  },
  [SET_COPY_CURRENT_SURVEY]: (state, action) => {
    state.previewUrl = null;
    state.current = action.payload;
    return state;
  },
  [CLEAR_SURVEY_STORE]: state => {
    let updatedState = {
      ...initialState
    };
    return updatedState;
  },
  [SAVE_SURVEY_LOGO]: state => {
    state.getting = true;
    return state;
  },
  [SAVING_SURVEY_LOGO]: state => {
    state.getting = true;
    return state;
  },
  [SAVING_SURVEY_LOGO_SUCCEEDED]: (state, action) => {
    const { payload } = action;
    state.previewUrl = null;
    state.getting = false;
    return state;
  },
  [SAVING_SURVEY_LOGO_FAILED]: state => {
    state.getting = false;
    return state;
  },
  [GETTING_SURVEY_LOGO_URL_SUCCEEDED]: (state, action) => {
    const { url } = action.payload;
    state.previewUrl = url;
    return state;
  },
  [SEND_SURVEY_RESULT_RESPONSE]: state => {
    state.openSentResponseSnackbar = false;
    return state;
  },
  [SEND_SURVEY_RESULT_RESPONSE_SUCCEEDED]: state => {
    state.sendResponseSuccess = true;
    state.openSentResponseSnackbar = true;
    return state;
  },
  [SEND_SURVEY_RESULT_RESPONSE_FAILED]: state => {
    state.sendResponseSuccess = false;
    state.openSentResponseSnackbar = true;
    return state;
  },
  [CLOSE_SENT_RESPONSE_SNACKBAR]: state => {
    state.openSentResponseSnackbar = false;
    return state;
  },
  [SET_SURVEY_SETTINGS_DATA]: (state, action) => {
    state.surveySettingsData = { ...action.payload };
    return state;
  },
  [UNSET_SURVEY_SETTINGS_DATA]: state => {
    state.surveySettingsData = { ...initialState.surveySettingsData };
    return state;
  },
  [GET_SURVEY_RESULT_CSV_FILE]: (state) => {
    state.surveyResultCsv = {
      getting: true,
      isDownloading: true,
      gettingFileSucceeded: false,
      surveyResultCsvBlob: {}
    };
    return state;
  },
  [GETTING_SURVEY_RESULT_CSV_FILE_SUCCEEDED]: (state, action) => {
    state.surveyResultCsv = {
      getting: false,
      gettingFileSucceeded: true,
      surveyResultCsvBlob: action.payload
    };
    return state;
  },
  [GETTING_SURVEY_RESULT_CSV_FILE_FAILED]: state => {
    state.surveyResultCsv = {
      getting: false,
      gettingFileSucceeded: false,
      surveyResultCsvBlob: {}
    };
    return state;
  },
  [DOWNLOADED_SURVEY_RESULT_CSV_FILE]: state => {
    state.surveyResultCsv = {
      ...state.surveyResultCsv,
      isDownloading: false,
      gettingFileSucceeded: false,
      surveyResultCsvBlob: {}
    };
    return state;
  },
  [UPDATE_SURVEY_FILTERS]: (state, action) => {
    state.gettingPaginated = true;
    state.filters = {
      ...state.filters,
      ...action.payload
    }
    return state;
  },
  [RESET_SURVEY_FILTERS]: state => {
    state.gettingPaginated = true;
    state.filters = { ...initialState.filters }
    return state;
  },
  [UPDATE_INDIVIDUAL_SURVEY_RESULT_FILTERS]: (state, action) => {
    state.individualSurveyResultFilters = {
      ...state.individualSurveyResultFilters,
      ...action.payload
    }
    return state;
  },
  [RESET_INDIVIDUAL_SURVEY_RESULT_FILTERS]: state => {
    state.individualSurveyResultFilters = { ...initialState.individualSurveyResultFilters }
    return state;
  },
  [UPDATE_SURVEY_RESULT_FILTERS]: (state, action) => {
    state.getting = true;
    state.surveyResultFilters = {
      ...state.surveyResultFilters,
      ...action.payload
    }
    return state;
  },
  [RESET_SURVEY_RESULT_FILTERS]: state => {
    state.getting = true;
    state.surveyResultFilters = { ...initialState.surveyResultFilters }
    return state;
  },
});
